// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A--xG","type":"styles_type__1LPjZ","choices":"styles_choices__1tZWN"};